module.exports = __webpack_public_path__ + "images/Economic_Games.jpg?v=a1ae4329f7ad70fb3180ac242751a380";